mutation CanvasDocumentDownload($canvasDocumentId: ID!) {
  canvasDocumentDownload(canvasDocumentId: $canvasDocumentId) {
    downloadUrl
  }
}
